module.exports = __webpack_public_path__ + "static/media/uni_logo.fdc98464.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logos/uni_logo.svg
// module id = 566
// module chunks = 0